import request from '@lib/request'
// eslint-disable-next-line no-undef
const env = process.env.NODE_ENV
function IsTest() {
  const hostUrl = window.location.href
  return hostUrl.indexOf('org.qupeiyin.com') == -1
}
const tokenHost =
  env === 'development'
    ? 'https://actsdtest.qupeiyin.cn'
    : IsTest() == true
      ? 'https://actsdtest.qupeiyin.cn'
      : 'https://actsd.qupeiyin.cn'

const GetQiniuToken = () => {
  return request
    .get(`${tokenHost}/qiniu/token`, {
      needSign: true
    })
    .then(response => {
      return response.data
    })
}

/**
 * 腾讯cos存储配置参数获取
 * @param {string} type  // file pic mp4
 * @returns
 */
const TxCosToken = (type = 'file') => {
  return request.get(`${tokenHost}/cos/config`, {
    params: {
      uploadType: type
    },
    needActSign: true
  }).then((response) => {
    return response.data
  })
}

export default {
  GetQiniuToken,
  TxCosToken
}
